export default "__VITE_ASSET__CRMgQ4lI__"